import React from 'react';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import CrossIcon from '../assests/croosicon.png'; 
import './CommonTicket.css'; 

const TicketDetailsModal = ({ open, handleClose, selectedTicket }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box className="ticket-modal">
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 2,
          }}
        >
          <Typography sx={{ fontSize: '20px', color: '#362B24', fontWeight: '700' }}>
            Ticket Details
          </Typography>
          <IconButton onClick={handleClose}>
            <img src={CrossIcon} alt="Cross" style={{ height: '24px', width: '24px' }} />
          </IconButton>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography className='modal-texts'>Ticket title</Typography>
          <Typography className='modal-texts-1'>{selectedTicket?.title || "N/A"}</Typography>

          <Typography className='modal-texts'>Topic</Typography>
          <Typography className='modal-texts-1'>{selectedTicket?.subject || "N/A"}</Typography>

          <Typography className='modal-texts'>Description</Typography>
          <Typography className='modal-texts-1'>{selectedTicket?.description || "N/A"}</Typography>

          <Typography className='modal-texts'>Status</Typography>
          <Typography className='modal-texts-1'>{selectedTicket?.status || "N/A"}</Typography>

          <Typography className='modal-texts'>Created On</Typography>
          <Typography className='modal-texts-1'>
            {selectedTicket?.createdAt ? new Date(selectedTicket?.createdAt).toLocaleDateString() : "-"}
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default TicketDetailsModal;
